const config = {
FINANCE_SERVICE_URL: 'https://financeserviceeu.shipsy.io/api',
  API_BASE_URL: 'https://projectxeuapi.shipsy.io/api',
  ANALYTICS_FRONTEND_BASE_URL: 'analyticsdashboard.eu.shipsy.io',
  IFRAME_NON_STRICT_MODE: false,
  FIREBASE_CONFIG: {
       apiKey: "AIzaSyBS7-u48IAJzePDpwM-nbKNXULw8kD7HL4",
       authDomain: "notification-service-418009.firebaseapp.com",
       databaseURL: "https://notification-service-418009-default-rtdb.firebaseio.com",
       projectId: "notification-service-418009",
       storageBucket: "notification-service-418009.appspot.com",
       messagingSenderId: "413910393309",
       appId: "1:413910393309:web:18279bf70b4ef30ee9d634",
       measurementId: "G-9SKNTTVQEC",
   },
   FIREBASE_VAPID_KEY: "BMJxxP73j8ok0wOvo5Ak_qked8D9oZW4-FhMsqie5JGh08HUvWcWpQKuX7vT2KIzQ9ahK7Q8ujQdcs15G7y8m4A",
   FIRESTORE_DB_ID: "notification-service-prod",
   WB_BASE_URL: 'https://n8nwebhook.shipsy.io/webhook/ticketing-tool',
};
export default config;
